import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="message-recipients"
export default class extends Controller {
  
  static targets = ["status", "query"]
  
  resetInputs() {
    this.queryTarget.value = ""
    this.statusTarget.value = ""
  }
  
}
